<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="isLoaded" :caption="isLoaded  ? 'Показать ' + this.topCount : 'Еще'" :expandable="!((totalPages == loadedPages) && (this.topCount > this.items.length))">
      <div
        v-show="isLoading && loadedPages < 0"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-show="!(isLoading && loadedPages == 0)">
          <v-items-field
            :items = getScheduledActions()
            @click = "onActionClick($event)"
            smallIcons
          >
          </v-items-field>  
      </div>  
    </v-panel-title>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from '../info/PanelTitle'
  import profile from './index.js'
  import vItemsField from '../common/ItemsField'

  export default {
    name: 'v-actionlogs-panel',
    components: {vPanelTitle, vItemsField},
    data: () => ({
      id: null,
      items: [],
      totalPages: 0,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false,
      actions () {
        return new Map([
          ['OTHER', 'Неизвестная операция'],
          ['LOGIN', 'вход в систему']
        ])
      }
    }),
    props: {
      fillHeight: {
        type: Boolean,
        default: false
      },
      topCount: {
        type: Number,
        default: 2
      }
    },
    created () {
      this.fetchItems()
    },
    computed: {
      ...mapGetters({
        getPostTypes: 'getPostTypes'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lastItems () {
        return this.items.slice(this.topCount)
      }
    },
    methods: {
      switchItems () {
        if (!this.isLoaded) {
          if (this.totalPages > this.loadedPages) {
            this.fetchItems()
          }
        } else {
          this.isLoaded = false
          this.loadedPages = 1
          this.items = this.topItems
        }
      },
      formatDateTime (dateTime) {
        return formats.formatDateTime(dateTime)
      },
      formatActionContent (item) {
        let fstrategy = profile.createStrategy(this, 'ACTION')
        if (!fstrategy) {
          return
        }
        return fstrategy.viewContentListComp(fstrategy.createModelFromData(item))
      },
      getScheduledActions () {
        let fstrategy = profile.createStrategy(this, 'ACTION')
        if (!fstrategy) {
          return
        }
        let actions = this.items
        return actions.map(al => {
          let model = fstrategy.createModelFromData(al)
          let icon = al.started && al.resultCode || al.scheduled && 'SCHEDULE'
          return {
            title: `<b>${fstrategy.viewTitle(model)}</b> (${al.clientNameShort})`,
            date: al.finished || al.scheduled || al.started,
            text: fstrategy.viewContentListComp(model),
            icons: [icon],
            time: al.finished || al.scheduled || al.started,
            id: al.id
          }
        }).sort((b, a) => a.time - b.time)
      },
      onActionClick (item) {
        profile.openLogAction(item.id, null)
      },
      getItems (cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка операций '})
        }
        server.apiGetParams(
          '/api/me/actions',
          {
            actions: null,
            size: this.topCount,
            page: this.loadedPages,
            sort: 'started,desc'
          },
          cb,
          cbError)
      },
      fetchItems () {
        if (!this.isLoading) {
          // this.items = []
          this.isLoading = true
          this.getItems((data) => {
            this.items = this.items.concat(data.content)
            this.totalPages = data.totalPages
            this.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages
            this.isLoading = false
            this.isLoaded = (this.totalPages === this.loadedPages)
            if (data.number === 0) {
              this.$store.dispatch('fetchDashboardCounters')
            }
          })
        }
      }
    }
  }

</script>
<style>
.align-end{
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// ActionLogsPanel.vue?7bd8b4c3